export default class TraceSequence {
  /**
   * Create new trace Sequence and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj, index) {
    Object.assign(this, obj)

    // Set a unique identifier
    this.key = `${index}-${obj.sequence}`
  }

  /**
   * @return {Date}
   */
  get timestampUtc () {
    return this._timestampUtc
  }

  /**
   * @param {string} value
   */
  set timestampUtc (value) {
    this._timestampUtc = new Date(value)
  }
}
